import {Container, Header} from './IndicatorsAndSignals.style'
import IdInterPretationsTable from '../../../components/tables/[id]/interpretations/IdInterpretetions'

import TitleDescriptionInput from '../../../components/customInput/TitleDescriptionInput'
import IndicatorScale from './components/IndicatorScaleComponent'
import SignalsSetComponent from './components/SignalsSetComponent'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {
    LinkedInterpretations
} from '../../../components/tables/[id]/recommendations/IdRecommendations'

import {initCurrent, updateCurrent} from '../../../redux/slice/currentItem'
import FiltersComponent, {UnitElements} from './components/FIltersComponent'
import {getScaleTypeColor} from '../../subjects/Subject'
import _ from 'underscore'
import {RemoveBtn} from "../../../components/listMenu/listMenu";
import {patchRemove} from "../../../redux/slice/data";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import { LeftSide, NavElement } from '../../subjects/Subject.style';

export const getSubjectId = () => {
    return window.location.pathname.split('/').filter((it) => it)[0]
}

export const deepClone = (obj: any) => {
    return JSON.parse(JSON.stringify(obj))
}

let cbAgeCd = new Date().getTime();

export const WarningCircle = (props: any) => {

    return <svg

        width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
        marginTop: (props.top || 0) + 'px',
        marginLeft: (props.left || 5) + 'px',
        float: 'right'
    }}>
        <mask id="mask0_588_1776" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="1" y="1" width="18"
              height="18">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 3.375C6.34111 3.375 3.375 6.34111 3.375 10C3.375 13.6589 6.34111 16.625 10 16.625C13.6589 16.625 16.625 13.6589 16.625 10C16.625 6.34111 13.6589 3.375 10 3.375ZM1.625 10C1.625 5.37462 5.37462 1.625 10 1.625C14.6254 1.625 18.375 5.37462 18.375 10C18.375 14.6254 14.6254 18.375 10 18.375C5.37462 18.375 1.625 14.6254 1.625 10ZM10 5.375C10.4832 5.375 10.875 5.76675 10.875 6.25V10.625C10.875 11.1082 10.4832 11.5 10 11.5C9.51675 11.5 9.125 11.1082 9.125 10.625V6.25C9.125 5.76675 9.51675 5.375 10 5.375ZM10 12.5584C9.51675 12.5584 9.125 12.9502 9.125 13.4334C9.125 13.9167 9.51675 14.3084 10 14.3084H10.0083C10.4916 14.3084 10.8833 13.9167 10.8833 13.4334C10.8833 12.9502 10.4916 12.5584 10.0083 12.5584H10Z"
                  fill="black"/>
        </mask>
        <g mask="url(#mask0_588_1776)">
            <rect width="20" height="20" fill="#FF9000"/>
        </g>
    </svg>

}
const IndicatorsAndSignals = () => {
    const {indicators, interpretations} = useAppSelector((state) => {
        return state.data
    })

    const [tab, setTab] = useState('')
    const [age, setAge] = useState({})
    const [language, setLanguage] = useState<string>('en')
    const [isAddLanguageModalOpen, setIsAddLanguageModalOpen] = useState(false)
    const [selectedNewLanguage, setSelectedNewLanguage] = useState('')
    const [localDescription, setLocalDescription] = useState<string>('')


    const dispatch = useAppDispatch()

    const {pathname} = useLocation()

    const {currentItem} = useAppSelector((state: any) => {
        return state
    })
    let indicator = currentItem.data || {}
    
    // Извлечение доступных языков
    const availableLanguages = (() => {
        if (!indicator?.name || typeof indicator.name !== 'object') {
            return ['en']
        }
        return Object.keys(indicator.name)
    })()
    
    // Обработка мультиязычных полей
    const indicatorName = (() => {
        if (indicator?.name && typeof indicator.name === 'object') {
            return indicator.name[language] || ''
        }
        return language === 'en' ? indicator?.name || '' : (indicator?.[`name_${language}`] || '')
    })()
    
    const indicatorDescription = (() => {
        if (indicator?.description && typeof indicator.description === 'object') {
            return indicator.description[language] || ''
        }
        return language === 'en' ? indicator?.description || '' : (indicator?.[`description_${language}`] || '')
    })()
    const id = pathname.split('/').pop() || ''

    useEffect(() => {
        dispatch(initCurrent({data: indicators[id], type: 'indicator'}))
    }, [id, indicators])

    useEffect(() => {
        setLocalDescription(indicatorDescription)
    }, [indicatorDescription, language])

    const handleChangeIndicator = async (item: any) => {
        const update: any = {};
        
        // Обработка мультиязычных полей
        if (item.name !== undefined) {
            if (indicator?.name && typeof indicator.name === 'object') {
                // Если name - объект, обновляем значение для выбранного языка
                update.name = { ...indicator.name, [language]: item.name };
            } else {
                // Если name - строка, сохраняем как есть
                update.name = item.name;
            }
        }
        
        if (item.description !== undefined) {
            setLocalDescription(item.description)
            if (indicator?.description && typeof indicator.description === 'object') {
                // Если description - объект, обновляем значение для выбранного языка
                update.description = { ...indicator.description, [language]: item.description };
            } else {
                // Если description - строка, сохраняем как есть
                update.description = item.description;
            }
        }
        
        // Добавляем остальные поля
        Object.keys(item).forEach(key => {
            if (key !== 'name' && key !== 'description') {
                update[key] = item[key];
            }
        });
        
        // Создаем обновленный объект, сохраняя мультиязычные поля
        const updatedData = {
            ...filter, 
            ...indicator, 
            ...update
        }
        
        // Если update содержит мультиязычные поля, используем их вместо indicator
        if (update.name && typeof update.name === 'object') {
            updatedData.name = update.name
        }
        if (update.description && typeof update.description === 'object') {
            updatedData.description = update.description
        }
        
        dispatch(updateCurrent(updatedData))
    }

    const handleLanguageChange = (newLanguage: string) => {
        if (newLanguage === language) return
        
        // Сохраняем текущее значение description в текущем языке
        if (localDescription !== undefined && localDescription !== null) {
            const currentDescriptionObj = indicator?.description && typeof indicator.description === 'object' 
                ? { ...indicator.description, [language]: localDescription }
                : { [language]: localDescription }
            
            dispatch(updateCurrent({
                description: currentDescriptionObj
            }))
        }
        
        // Переключаемся на новый язык
        setLanguage(newLanguage)
    }

    const handleRemoveLanguage = (langToRemove: string) => {
        if (availableLanguages.length <= 1) {
            alert('Cannot remove the last language')
            return
        }
        
        if (langToRemove === 'en') {
            alert('Cannot remove English language')
            return
        }
        
        if (window.confirm(`Are you sure you want to remove language "${langToRemove.toUpperCase()}"?`)) {
            // Удаляем язык из name
            const updatedName = { ...indicator.name }
            delete updatedName[langToRemove]
            
            // Удаляем язык из description
            const updatedDescription = { ...indicator.description }
            delete updatedDescription[langToRemove]
            
            // Обновляем данные в Redux
            dispatch(updateCurrent({
                name: updatedName,
                description: updatedDescription
            }))
            
            // Если удаляемый язык был активным, переключаемся на английский
            if (language === langToRemove) {
                setLanguage('en')
            }
        }
    }

    const handleAddLanguage = () => {
        const languageCode = selectedNewLanguage.toLowerCase().trim()
        
        if (languageCode && languageCode.length <= 2 && indicator && !availableLanguages.includes(languageCode)) {
            const newNameObj = typeof indicator.name === 'object'
                ? { ...indicator.name, [languageCode]: '' }
                : { en: indicator.name || '', [languageCode]: '' }
            
            const newDescriptionObj = typeof indicator.description === 'object'
                ? { ...indicator.description, [languageCode]: '' }
                : { en: indicator.description || '', [languageCode]: '' }
            
            // Обновляем данные в Redux
            dispatch(updateCurrent({
                name: newNameObj,
                description: newDescriptionObj
            }))
            
            // Переключаемся на новый язык
            setLanguage(languageCode)
            
            // Закрываем модальное окно
            setIsAddLanguageModalOpen(false)
            setSelectedNewLanguage('')
        }
    }

    // indicator.age = getAges()[0]

    // const indicatorId = id;
    // const _subjectIds = (indicator.subjectIds || []).reduce((acc: any, it: any) => {
    //     return {...acc, [it]: true}
    // }, {})
    // const fileredInterpretations = Object.values(interpretations || []).filter(
    //     (it: any) => {
    //         let isOk = false;
    //         it.signalSets.forEach((signalSet: any) => {
    //             signalSet.signals.forEach((it: any) => {
    //                 isOk = isOk || it.indicatorId == indicatorId
    //             })
    //         })

    //         return isOk;
    //     })


    const getFilter = () => {
        return {
            scaleType: indicator?.scaleType || {name: 'RAGAR'},
            unitType: UnitElements.find((it: any) => it?.unitType == indicator?.unitType) || UnitElements[0],
            age: indicator?.age,
        }
    }
    const filter = getFilter();

    let groups = [{
        name: 'Unified',
    }, {
        name: 'Female',
        gender: 'w',
    }, {
        name: 'White Female',
        gender: 'w',
        skin: 'white',
    }, {
        name: 'Black Female',
        gender: 'w',
        skin: 'black',
    }, {
        name: 'AsianFemale',
        gender: 'w',
        skin: 'asian',
    }, {
        name: 'Male',
        gender: 'm',
    }, {
        name: 'White Male',
        gender: 'm',
        skin: 'white',
    }, {
        name: 'Black Male',
        gender: 'm',
        skin: 'black',
    }, {
        name: 'Asian Male',
        gender: 'm',
        skin: 'asian',
    }].map(it => {
        return {...it, key: [it.gender || '', it.skin || ''].filter(it => it).join('_')}
    })

    const getAgeId = () => indicator?.age?.id || '';

    function getSignals() {
        let ageId = getAgeId();

        if (!ageId) {
            return tab ? signalsObj[tab]?.signals || [] : indicator?.signals
        } else {
            if (tab) {
                let sObj = (signalsObj || {})[tab] || {};
                return (sObj.ageSignals || {})[ageId]
            } else {
                return (indicator?.ageSignals || {})[ageId]
            }
        }
    }

    function setSignals(data: any[]) {
        let ageId = getAgeId();

        if (ageId) {
            signalsObj[tab] = signalsObj[tab] || {}
            let ageSignals = copy((tab ? signalsObj[tab].ageSignals : indicator.ageSignals)) || {};
            ageSignals[ageId] = data;

            if (tab) {
                signalsObj[tab].ageSignals = ageSignals
            }

            let obj = tab ? {signalsObj: signalsObj} : {ageSignals}

            handleChangeIndicator(obj)
        } else {
            if (tab) {
                signalsObj[tab] = signalsObj[tab] || {};
                signalsObj[tab].signals = data
            }
            let obj = tab ? {signalsObj: signalsObj} : {signals: data}

            handleChangeIndicator(obj)
        }

    }


    let signalsObj = deepClone(indicator.signalsObj || {});
    let scaleArr = ((indicator.scaleType || {}).name || 'RAGAR').split('');

    function isFull(obj: any) {
        let signals = (obj || {}).signals

        const signalColors = getScaleTypeColor(indicator?.scaleType?.name || 'RAGAR')
        if (!scaleArr || !signals) {
            return null;
        }

        let isOk = true;
        signalColors.forEach((it: any, ind: number) => {
            if (signals[ind] && (signals[ind].valueFrom || signals[ind].valueFrom == '0') && signals[ind].valueFrom == +signals[ind].valueFrom) {
            } else {
                isOk = false;
            }
        })

        return isOk ? signals : null;
    }

    function getAges() {
        let tabs = tab ? ((indicator?.signalsObj || {})[tab] || {}).ages : indicator?.ages

        return tabs || [];
        // return [{from: 12, to: 24, id: 1234}];
    }

    const resetAge = () => {
        handleChangeIndicator({...indicator, age: null})

    }

    const getUnitTypes = (indicator:any) => {
        let unitTypes = indicator?.unitTypes || [];
        let unitType = indicator?.unitType || {};
        let res =  unitTypes && unitTypes.length ? unitTypes : [{name: unitType.name}]
        return copy(res);
    }
    const copy = (data: any) => data ? JSON.parse(JSON.stringify(data)) : {};

    function setAges(ages: any[]) {
        let _indicator = copy(indicator)
        if (tab) {
            _indicator.signalsObj ??= {}
            _indicator.signalsObj[tab] ??= {}
            _indicator.signalsObj[tab].ages = ages;
        } else {
            _indicator.ages = ages;
        }
        handleChangeIndicator(_indicator)
    }

    let ages = getAges();
    let isEditor = (global as any)?.isEditor;
    let unitTypes = getUnitTypes(indicator);

    return (
        <Container data-animch>
            {/* Language Switcher */}
            <LeftSide style={{ justifyContent: 'flex-start', marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                {availableLanguages.map((lang, index) => (
                    <div key={lang} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginRight: 4
                    }}>
                        <NavElement
                            as="span"
                            selected={language === lang}
                            onClick={() => handleLanguageChange(lang)}
                            style={{ cursor: 'pointer', marginRight: 4 }}
                        >
                            {lang.toUpperCase()}
                        </NavElement>
                        {lang !== 'en' && availableLanguages.length > 1 && (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleRemoveLanguage(lang)
                                }}
                                style={{
                                    marginLeft: 4,
                                    cursor: 'pointer',
                                    color: '#ff4444',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}
                            >
                                ×
                            </span>
                        )}
                    </div>
                ))}
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setIsAddLanguageModalOpen(true)}
                    style={{ marginLeft: 8, fontSize: '12px', padding: '4px 8px' }}
                >
                    + Add Language
                </Button>
            </LeftSide>
            {/* title  */}
            <TitleDescriptionInput
                name={indicatorName}
                namePlaceholder={'Enter Biomarker name ...'}
                descriptionPlaceholder={'Enter biomarker description ...'}
                callback={(data) => handleChangeIndicator(data)}
                description={localDescription}
            />
            {/* header  */}
            <Header data-rel>
                <h3>Indicator Scale:</h3>
                <FiltersComponent
                    indicator={indicator}
                    filter={filter}
                    scaleData={indicator?.scaleType}
                    unitData={indicator?.unitType}
                    ages={ages}
                    callbackAge={(data: any[]) => {
                        cbAgeCd = new Date().getTime();
                        setAges(_.sortBy(data, (it: any) => +it.from || 0))
                    }}
                    callback={(data: any) => {
                        // setFilter((prev) => ({...prev, ...data}))
                        if (new Date().getTime() - cbAgeCd < 500) {
                            return;
                        }
                        handleChangeIndicator(data)
                    }}
                />
            </Header>
            <div style={{
                background: '#efefef',
                opacity: .2,
                height: '1px',
                width: '100%',
                margin: '5px 0 20px 0'
            }}></div>

            <div style={{marginBottom: '20px', position: 'relative'}}>
                {(groups || []).map((it, ind) => {
                    return (<span className={'tab ' + (tab == it.key ? 'tab-active' : '')} key={ind} onClick={() => {
                        setTab(it.key)
                        resetAge()
                    }}>
                    {it.name} {!isFull(!it.key ? {signals: indicator.signals} : signalsObj[it.key]) &&
                        <WarningCircle top={-1}/>}
                </span>)
                })}
            </div>
            {/* body  */}
            <IndicatorScale
                scaleType={indicator?.scaleType}
                signalsIds={getSignals()}
                callback={(data: any) => setSignals(data)}
            />
            <br/>
            <h3>Signals Sets:</h3>
            <SignalsSetComponent
                scaleType={indicator?.scaleType}
                signalsIds={getSignals()}
                callback={(data: any) => setSignals(data)}
            /> <br/>
            {/*<div style={{*/}
            {/*    background: '#efefef',*/}
            {/*    opacity: 0,*/}
            {/*    height: '1px',*/}
            {/*    width: '100%',*/}
            {/*    margin: '5px 0 20px 0'*/}
            {/*}}></div>*/}
            {/*<div>Different Unit Types</div>*/}
            <button className={'btn'} style={{marginTop: 20, marginBottom: 10}}
                    disabled={!isEditor}
                    onClick={() => {
                handleChangeIndicator({unitTypes: [...unitTypes || [], {}]})
            }}>Add Unit Type
            </button>
            <div>
            {unitTypes.map((it: any, ind: number) => {
                return (<div key={ind} className={'indicatorItem'}>
                    <div className="ib">
                        <input
                            disabled={!isEditor}
                            type="string" value={it.name} placeholder="UnitType Name" onChange={(e) => {
                            // let unitTypes = [...indicator?.unitTypes]
                            unitTypes[ind] = {...unitTypes[ind] || {}};
                            unitTypes[ind].name = e.target.value;

                            handleChangeIndicator({unitTypes})
                        }
                        }/>
                    </div>
                    <div className="ib">
                        <input
                            disabled={!isEditor}
                            type="number" value={it.mult} placeholder="Multiplicator" onChange={(e) => {
                            // let unitTypes = [...indicator?.unitTypes]
                            unitTypes[ind] = {...unitTypes[ind] || {}};
                            unitTypes[ind].mult = e.target.value;

                            handleChangeIndicator({unitTypes})
                        }
                        }/>
                    </div> <div className="ib">
                        <input
                            disabled={!isEditor}
                            type="number" value={it.toFixed} placeholder="Symbols to round" onChange={(e) => {
                            // let unitTypes = [...indicator?.unitTypes]
                            unitTypes[ind] = {...unitTypes[ind] || {}};
                            unitTypes[ind].toFixed = e.target.value;

                            handleChangeIndicator({unitTypes})
                        }
                        }/>
                    </div>
                    {/*{ind !== 0 && <div className="ib removeUnitType" onClick={() => {*/}
                    {isEditor && ind != 0 && <div className="ib removeUnitType" onClick={() => {
                        handleChangeIndicator({unitTypes: (unitTypes || []).filter((it:any, ind1:number) => ind != ind1)})

                    }}>
                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                             focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon">
                            <path
                                d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                        </svg>
                    </div>}

                </div>)
            })}
            </div>

            {/* <h3>Disease:</h3>
            <LinkedInterpretations
                data={fileredInterpretations}
            /> */}

            {/* Add Language Modal */}
            <Dialog open={isAddLanguageModalOpen} onClose={() => setIsAddLanguageModalOpen(false)}>
                <DialogTitle>Add New Language</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Language Code"
                        value={selectedNewLanguage}
                        onChange={(e) => setSelectedNewLanguage(e.target.value)}
                        placeholder="e.g., fr, es, ru"
                        inputProps={{ maxLength: 2 }}
                        style={{ marginTop: 16 }}
                        helperText="Enter 2-letter language code (e.g., fr for French, es for Spanish)"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddLanguageModalOpen(false)}>Cancel</Button>
                    <Button 
                        onClick={handleAddLanguage} 
                        variant="contained"
                        disabled={!selectedNewLanguage || selectedNewLanguage.length > 2 || availableLanguages.includes(selectedNewLanguage.toLowerCase())}
                    >
                        Add Language
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

function isFullByIndicator(indicator: any, obj: any) {
    let signals = (obj || {}).signals

    const signalColors = getScaleTypeColor(indicator?.scaleType?.name || 'RAGAR')
    if (!signalColors || !signals) {
        return null;
    }

    let isOk = true;
    signalColors.forEach((it: any, ind: number) => {
        if (signals[ind] && (signals[ind].valueFrom || signals[ind].valueFrom == '0') && signals[ind].valueFrom == +signals[ind].valueFrom) {
        } else {
            isOk = false;
        }
    })

    return isOk ? signals : null;
}

export const isFullByAge = (indicator: any, age: any, key: any) => {
    let obj = key ? (indicator.signalsObj || {})[key] || {} : indicator;
    let _age = +age;
    let ages = obj.ages;
    let ageKey;
    _.each(ages, (item, ind) => {
        if ((!+item.from || (+item.from <= _age)) && (!+item.to || (+item.to >= _age))) {
            ageKey = item.id;
        }
    })

    let _obj = ageKey ? {signals: (obj.ageSignals || {})[ageKey]} : {signals: obj.signals};
    // let ageKey = indicator.ages[0];
    return isFullByIndicator(indicator, _obj)
}

export default IndicatorsAndSignals